module.exports = __webpack_public_path__ + "img/images_homebanner_2_3.025bc1ce.png";